"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _core = require("@material-ui/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../theme");
var _templateObject;
var borderRadius = _theme.theme.shape.borderRadius,
  spacing = _theme.theme.spacing;
var Styled = (0, _styledComponents["default"])(_core.Accordion)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  section {\n    margin: ", ";\n    border-radius: ", "px;\n\n    &:first-child {\n      margin-top: ", "px;\n    }\n\n    &::before {\n      opacity: 0;\n    }\n  }\n"])), "".concat(spacing(4), "px 0 0"), borderRadius, spacing(4));
exports.Styled = Styled;